import React, { useState } from "react";

export default function MatrixTable({
  block,
  principles,
  responses,
  updateMatrix,
  showToast,
  isReadOnly
}) {

  const [editingCell, setEditingCell] = useState(null);
  const editorQuestions = ["Q1C","Q4","Q5","Q6"];

  return (
    <div className="table-responsive table-card">
      <table className="table table-bordered align-middle">
        <thead>
          <tr>
            <th>Disclosure Questions</th>

            {principles.map((principle) => (
              <th key={principle.principle_code} className="text-center">
                {principle.principle_code}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            <td
              colSpan={principles.length + 1}
              
            >
              <div className="section_b_title">{block.block_title}</div>
            </td>
          </tr>

          {block.questions.map((question) => (

  <React.Fragment
    key={question.question_code}
  >

    <tr>

      <td>
        <div>
          <strong>
            {question.question_code}
          </strong>{" "}
          {question.question_text}
        </div>
      </td>

      {principles.map((principle) => {

        const value =
          responses?.matrix?.[
            question.question_code
          ]?.[
            principle.principle_code
          ] || "";

        return (

          <td key={principle.principle_code} className="text-center">

            {question.question_type ==="matrix_boolean" ? (
              
           <>  
    <label className="q10-label">
      Yes
    </label>
              <input
                className="matrix_checkbox"
                type="checkbox"
                checked={value === "Yes"}
                disabled={isReadOnly}
                onChange={(e) =>
                  updateMatrix(
                    question.question_code,
                    principle.principle_code,
                    e.target.checked
                      ? "Yes"
                      : "No"
                  )
                }

              />
</>
          ) : editorQuestions.includes(
      question.question_code
    ) ? (

      isReadOnly ? (

        value ? (

          <span
            className="reason-badge saved"
            style={{
              cursor: "pointer"
            }}
            onClick={() =>
              setEditingCell({
                questionCode:
                  question.question_code,
                principleCode:
                  principle.principle_code
              })
            }
          >
            👁️
          </span>

        ) : (

          <span
            style={{
              color: "#999",
              fontSize: "12px"
            }}
          >
            N/A
          </span>

        )

      ) : (

        <span
          className={
            value
              ? "reason-badge saved"
              : "reason-badge add"
          }
          style={{
            cursor: "pointer"
          }}
          onClick={() =>
            setEditingCell({
              questionCode:
                question.question_code,
              principleCode:
                principle.principle_code
            })
          }
        >
          {value
            ? "✓"
            : question.question_code ===
              "Q1C"
            ? "🔗"
            : "✏️"}
        </span>

      )

) : (

                

                <input type="text" className="form-control form-control-sm" value={value} disabled={isReadOnly}
                  onChange={(e) =>
                    updateMatrix(
                      question.question_code,
                      principle.principle_code,
                      e.target.value
                    )
                  }
                />

)}

          </td>

        );

      })}

    </tr>

    {editingCell?.questionCode ===
  question.question_code && (

<tr>
  <td>&nbsp;</td>
  <td colSpan="10">
    <div className="le-card ecf-card">
      <div className="reason-editor-header">

  {isReadOnly
    ? "View Details"
    : "Edit Details"}

  {" - "}

  {question.question_code}

  {" - "}

  {editingCell.principleCode}

</div>

      {question.question_code === "Q1C" ? (
        <input
          type="url"
          className="form-control"
          placeholder="https://example.com"
          readOnly={isReadOnly}
          value={responses?.matrix?.[editingCell.questionCode]?.[editingCell.principleCode] || ""}
          onChange={(e) =>
            updateMatrix(
              editingCell.questionCode,
              editingCell.principleCode,
              e.target.value
            )
          }
        />
      ) : (
        <textarea
          className="form-control"
          rows={6}  readOnly={isReadOnly}
          value={responses?.matrix?.[editingCell.questionCode]?.[editingCell.principleCode] || ""}
          onChange={(e) =>
            updateMatrix(
              editingCell.questionCode,
              editingCell.principleCode,
              e.target.value
            )
          }
        />
      )}

      <div className="ecf-footer">

        <button
          type="button"
          className="org-btn-cancel"
          onClick={() => setEditingCell(null)}
        >
          Cancel
        </button>
 {!isReadOnly && (
        <button
          type="button"
          className="org-btn-save"
          onClick={() => {
            const value =
              responses?.matrix?.[editingCell.questionCode]?.[
                editingCell.principleCode
              ]?.trim();

            if (!value) {
              alert(
                editingCell.questionCode === "Q1C"
                  ? "Policy URL is required"
                  : "Value is required"
              );
              return;
            }

            setEditingCell(null);
          }}
        >
          Save
        </button>
         )}
      </div>
     
    </div>
  </td>
</tr>

)}

  </React.Fragment>

))}

        </tbody>
      </table>

    </div>
  );
}